/* Footer responsive disclosure: collapsible on small screens, static navigation columns on desktop. */
(function () {
  'use strict';
  if (customElements.get('bb-footer')) return;

  class BBFooter extends HTMLElement {
    connectedCallback() {
      this.details = Array.from(this.querySelectorAll('.bb-footer__details'));
      this.mq = window.matchMedia('(min-width: 768px)');
      this.onChange = () => this.apply();
      this.mq.addEventListener?.('change', this.onChange);
      this.apply();
    }

    disconnectedCallback() {
      this.mq.removeEventListener?.('change', this.onChange);
    }

    apply() {
      const desktop = this.mq.matches;
      const initialMobile = this.lastDesktop === undefined && !desktop;
      const crossedToMobile = this.lastDesktop === true && !desktop;
      this.details.forEach((details) => {
        const summary = details.querySelector('summary');
        if (desktop) details.open = true;
        else if (initialMobile || crossedToMobile) details.open = false;
        if (summary) {
          summary.tabIndex = desktop ? -1 : 0;
          if (desktop) summary.setAttribute('aria-disabled', 'true');
          else summary.removeAttribute('aria-disabled');
        }
      });
      this.lastDesktop = desktop;
    }
  }

  customElements.define('bb-footer', BBFooter);
})();
